import axios from "axios";
import { API_BASE_URL } from "../constants";

export default class DataProtectionADService {
  static instance;
  resource = `${API_BASE_URL}/ad/`;

  constructor() {}

  static getInstance() {
    
    if (!DataProtectionADService.instance) {
      DataProtectionADService.instance =
        new DataProtectionADService();
    }

    return DataProtectionADService.instance;
  }

  async syncAssetsListWithAD(){
    const response = await axios.get(`${this.resource}fetch`, {
			params: {},
			headers: {
				Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
			},
		});
    return response.data.data
  }
}
